<template>
    <div class="adminUserList">
        <Breadcumb title="Accès aux résultats" :breadcumb-data="breadcumbData">
        </Breadcumb>
        <b-card v-show="user.userprofile.user_type.services.includes('softconcept')" no-body class="cardcontainer">
            <!-- Table controls -->
            <b-card-body>

                        <b-btn
                                variant="primary  md-btn-flat" style="text-align:center; margin-left:auto; margin-right:auto; width:250px;display:block;"
                                href="/rapport-groupe.pptx" target="_blank"
                        >
                            Télécharger le rapport groupe
                        </b-btn>
            </b-card-body>
        </b-card>
        <b-card v-show="user.userprofile.user_type.services.includes('softconcept')" no-body class="cardcontainer">
            <!-- Table controls -->
            <b-card-body>
                <template v-if="user.userprofile.related_companies.length > 1 && user.userprofile.softconcept">
                    <b-btn variant="primary  md-btn-flat" style="text-align:center; margin-left:auto; margin-right:auto; width:200px;display:block;"
                           :href="user.userprofile.softconcept" target="_blank">
                        Accéder aux résultats en ligne
                    </b-btn>
                </template>
                <template v-else-if="user.userprofile.related_companies.length == 1 && user.userprofile.related_companies[0].softconcept">
                    <b-btn variant="primary  md-btn-flat" style="text-align:center; margin-left:auto; margin-right:auto; width:200px;display:block;"
                           :href="user.userprofile.related_companies[0].softconcept" target="_blank">
                        Accéder aux résultats en ligne
                    </b-btn>
                </template>
                <template v-else>
                    Veuillez attendre que vos résulats de périmètre soit disponibles.  Afin de respecter la confidentialité, si vous avez moins de 10 répondants, vous n’aurez pas accès au détail de vos résultats.
                </template>
            </b-card-body>
        </b-card>
        <b-card v-show="user.userprofile.user_type.services.includes('report')" no-body class="cardcontainer mt-3">
            <!-- Table controls -->
            <b-card-body>
                <h3>Télécharger vos rapports</h3>
                <b-table
                        :items="reportsData"
                        :fields="fields"
                        :striped="true"
                        :bordered="true"
                        class="card-table">
                    
                    <template :slot="$t('name')" slot-scope="data">
                        {{data.item.name}}
                    </template>
                    <template :slot="$t('download_document')" slot-scope="data">
                        <b-btn v-on:click="downloadResult(data.item.id)" variant="default btn-xs  md-btn-flat">
                            Télécharger
                        </b-btn>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import Breadcumb from '../components/breadcumb'
    import {GET_REPORT_SURVEY_REQUEST, GET_RESULT_REQUEST} from "../_store/administration/result/actiontypes";
    import slugify from 'slugify'

    export default {
        name: 'adminUserList',
        components: { Breadcumb, },
        computed: mapState({ user: state => state.user.user }),
        mounted() {
            this.breadcumbData = [
                { text: this.$t('welcome'), href: '/dashboard/' },
                { text: "Accès aux résultats", active: true },
            ];
            this.fields = [
                {
                    key: this.$t('name'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('download_document'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
            ];
            this.$store.dispatch(GET_REPORT_SURVEY_REQUEST)
                .then(response => {
                    this.reportsData = response.data.reports
                })
        },
        data() {
            return {
                breadcumbData: [],
                fields: [],
                reportsData: [],
                currentPage: 1
            };
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            downloadResult(report_id) {
                this.$store.dispatch(GET_RESULT_REQUEST, report_id)
                    .then(response => {
                        console.log("I GOT SURVEY")
                        console.log(response);
                        let report = response.data.report;
                        let type = report.extension;
                        let original_type = type;
                        if (type === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                            type = "xlsx";
                        }
                        const linkSource = report.file;
                        const downloadLink = document.createElement("a");
                        const fileName = slugify(report.name, '_') + "_" + report.id + "." + type;
                        let dataPart = '';
                        if (type === 'pdf'){
                            dataPart = 'data:application/pdf;base64,'
                        } else if (type === 'xlsx') {
                            dataPart = 'data:vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
                        } else if (type === 'xls') {
                            dataPart = 'data:application/vnd.ms-excel;base64,'
                        } else if (type === 'ppt') {
                            dataPart = 'data:application/vnd.ms-powerpoint;base64,'
                        } else if (type === 'pptx') {
                            dataPart = 'data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,'
                        }
                        downloadLink.href = dataPart + linkSource.substr(2).slice(0, -1);
                        downloadLink.download = fileName;
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(pdfBlobConvesion(linkSource, original_type), fileName);
                        }
                        else {
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                        }
                    })
                    .catch(error => {
                        console.log("ERROR is ====");
                        console.log(error)
                    })
            },
        },
    };
</script>
